module.exports = __webpack_public_path__ + "static/reserva_modelia-0dcfb1d584b7245023f5ab918808fc1f.jpg";